import { Link } from "@tanstack/react-router";

interface NotFoundViewProps {
	label?: string;
	description?: string;
	backHref?: string;
	backLabel?: string;
}

export function NotFoundView({
	label = "Page",
	description = "The page you were looking for doesn't exist.",
	backHref = "/",
	backLabel = "Back to leaderboard",
}: NotFoundViewProps) {
	return (
		<div className="min-h-svh bg-background px-4 py-24 text-foreground sm:px-6">
			<div className="mx-auto max-w-2xl">
				<p className="font-mono text-sm uppercase tracking-[0.14em] text-muted-foreground">
					&gt; Error · 404
				</p>
				<h1 className="mt-4 text-balance font-mono font-normal text-[clamp(1.5rem,3vw,2rem)] leading-[1.1] tracking-[-0.02em] text-foreground">
					<span className="text-brand">/</span>
					{label.toLowerCase()}-not-found
				</h1>
				<p className="mt-3 text-base leading-[1.55] text-muted-foreground">
					{description}
				</p>
				<Link
					to={backHref}
					className="mt-8 inline-flex min-h-10 items-center gap-2 border border-border bg-background px-4 font-mono text-sm uppercase tracking-[0.14em] text-foreground transition-[color,border-color,transform] hover:border-brand/40 hover:text-brand active:scale-[0.96]"
				>
					&gt; {backLabel}
				</Link>
			</div>
		</div>
	);
}
